import React, { memo, useState } from 'react';

interface CompanyLogoProps {
  symbol: string;
  /** Côté en pixels (carré). */
  size?: number;
  className?: string;
}

/**
 * Logo d'une société cotée (`/images/societes/{SYMBOLE}.png`), avec repli sur les initiales
 * du symbole si l'image manque. Décoratif : le symbole est toujours écrit à côté, d'où
 * `alt=''` — un lecteur d'écran ne le lirait pas deux fois.
 */
const CompanyLogo: React.FC<CompanyLogoProps> = ({ symbol, size = 36, className }) => {
  const [failed, setFailed] = useState(false);
  const radius = Math.round(size * 0.22);

  if (failed) {
    return (
      <span
        aria-hidden='true'
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: radius,
          flexShrink: 0,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: Math.max(9, Math.round(size * 0.28)),
          fontWeight: 700,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
        }}
      >
        {symbol.substring(0, 3)}
      </span>
    );
  }

  return (
    <img
      src={`/images/societes/${symbol}.png`}
      alt=''
      width={size}
      height={size}
      loading='lazy'
      decoding='async'
      className={className}
      onError={() => setFailed(true)}
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        flexShrink: 0,
        objectFit: 'contain',
        background: '#fff', // fond blanc pour les logos transparents, y compris en thème sombre
        border: '1px solid #f1f5f9',
      }}
    />
  );
};

export default memo(CompanyLogo);
